var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42167",
    "data-name": "Group 42167",
    transform: "translate(-172.827 -234.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20935",
    "data-name": "Path 20935",
    d: "M228.384,308.851a33.454,33.454,0,0,1-3.235-2.415Q201.415,282.5,177.727,258.5A14.183,14.183,0,0,1,176.4,239.86a14,14,0,0,1,17.817-4.179,19.6,19.6,0,0,1,4.355,3.427q23.417,23.434,46.742,46.951a24.067,24.067,0,0,1,2.022,2.787c1.3-1.217,2.076-1.923,2.821-2.666q23.4-23.656,46.816-47.294c7.3-7.347,18.754-5.489,23.091,3.622,2.72,5.7,1.617,11.852-3.023,16.542q-23.293,23.573-46.6,47.09a30.3,30.3,0,0,1-2.793,2.183c1.13,1.207,1.819,1.988,2.545,2.721q23.886,23.991,47.79,47.982c3.712,3.724,5.577,8.108,4.594,13.375-1.976,10.691-14.646,15.232-23.513,8.5a28.661,28.661,0,0,1-3.014-2.8q-23-23.225-45.961-46.486a16.919,16.919,0,0,1-1.81-2.712h-1.241a16.679,16.679,0,0,1-1.8,2.694c-15.639,15.864-31.36,31.662-46.962,47.564-4.493,4.579-9.859,5.554-15.63,4.142-9.483-2.3-12.928-14.211-6.579-22.1a33.634,33.634,0,0,1,2.417-2.573q23.293-23.545,46.6-47.09C225.829,310.783,226.739,310.179,228.384,308.851Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.52feb78299df46e6ba34aaf9f3b924de.svg";
export { ForwardRef as ReactComponent };